import { FC } from 'react'

import { getState } from 'commons/utils'
import { DateTime } from 'ui/components'
import { IconSize } from 'ui/components/Icon'
import { Info, InfoSet, InfoSetDirection } from 'ui/components/Info'
import { TextMask } from 'ui/components/TextMask'

import { AccountInformationProps } from './AccountInformationProps'

import { Column, Columns } from './styles'

export const AccountInformation: FC<AccountInformationProps> = (props) => {
  const {
    data: { businessType, entityType, stateOfIncorporation, primaryAccountOpeningDate, numberOfLicenses, einLabel, ein }
  } = props

  return (
    <InfoSet legend="Account Details" direction={InfoSetDirection.ROW}>
      <Columns>
        <Column>
          <Info label="Business Type">{businessType}</Info>
          <Info label="Entity Type">{entityType}</Info>
          <Info label="State of Incorporation or Organization">{getState({ state: stateOfIncorporation })}</Info>
        </Column>
        <Column>
          <Info label="Primary Account Opening Date">
            <DateTime date={primaryAccountOpeningDate} />
          </Info>
          <Info label={`${einLabel} #`}>
            {ein ? <TextMask text={ein} iconSize={IconSize.XS} valueType="EIN" /> : ''}
          </Info>
          <Info label="Number of Licenses">{numberOfLicenses}</Info>
        </Column>
      </Columns>
    </InfoSet>
  )
}
